export function reportClientSideError(
  e: Error,
  message = 'Unhandled error'
): string | void {
  return console.error(`Client: ${message}`, e);
}
